import { Alert } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ImportNoticeProps {
  file: string;
}

const ImportNotice: React.FC<ImportNoticeProps> = ({ file }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-3 d-flex justify-content-end">
        <a href={file} download className="btn btn-primary">
          <i className="ti ti-download me-2" />
          {t('import_download_template')}
        </a>
      </div>
      <Alert message={t("import_notice_format")} type="warning" showIcon />
    </>
  );
};

export default ImportNotice;
